export default "__VITE_ASSET__Cb6UO_vZ__"